import type { Activity, Level } from "@app-types/activity-data.types";
import { Box, Chip, ListItem, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { theme } from "@theme";

type RecentActivityProps = {
  activity: Activity;
  level: Level;
};

export const RecentActivity = ({ activity, level }: RecentActivityProps) => (
  <ListItem
    sx={{
      display: "block",
      padding: 1.625,
      border: `1px solid ${theme.palette.info.main}`,
      borderRadius: 2,
      background: theme.palette.secondary.main,
      textAlign: "left",
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 1.5,
        mb: 0.5,
      }}
    >
      <Typography sx={{ fontWeight: 700, minWidth: 0, overflowWrap: "anywhere" }}>
        {activity.title}
      </Typography>
      <Chip
        label="Complete"
        size="small"
        sx={{
          color: theme.palette.success.dark,
          backgroundColor: alpha(theme.palette.success.main, 0.12),
        }}
      />
    </Box>
    <Typography sx={{ fontSize: "0.875rem" }}>
      Tool: {activity.tool.replace("-ai", "").toUpperCase()}
      {" • Level: "}{level.toUpperCase()}
    </Typography>
  </ListItem>
);
